import React from "react"
import styled, { css } from "styled-components"
import { mixins } from "Styles"
import { theme } from "Theme"

const Navbar = styled.div`
  margin-bottom: 12px;
  text-align: center;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`
const Dot = styled.span`
  color: inherit;
  cursor: pointer;
  font-size: 36px;
  line-height: 8px;
  margin: 0 6px;
  opacity: 0.3;
  transition: opacity 0.25 ease;
  will-change: opacity;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  &.active {
    color: ${theme.colors.primary.base};
    opacity: 1;
  }
`

const FormNav = (props) => {
  const dots = []
  for (let i = 1; i <= props.totalSteps; i += 1) {
    const isActive = props.currentStep === i
    dots.push(
      <Dot key={`step-${i}`} className={`${isActive ? "active" : ""}`} onClick={() => props.goToStep(i)}>
        &bull;
      </Dot>
    )
  }

  return <Navbar>{dots}</Navbar>
}

export default FormNav
